// extracted by mini-css-extract-plugin
module.exports = {"loading":"Loading_loading___FQLv","fullscreen":"Loading_fullscreen__F5_yL"};